<template>
    <div class="live-book" v-if="contShow">
        <div class="load_box" v-if="tcShows=='true'">
            <img class="load_icon" src="../../../assets/videoImg/loading.gif" alt=""/>
        </div>
        <!-- <div class="book-trigon"></div> -->
        <img @click="contClick" class="book-clock" src="../../../assets/videoImg/black.png" alt=""/>
        <!-- 内容 -->
        <div class="book-content">
            <van-tag color="#E35458" style="padding:2px 4px;">拍卖中</van-tag>
            <div class="book-biaoti" @click="ppxq()">{{tuluTk.title}}</div>
        </div>
        <div class="book-tuwen">
            <div class="imgg" @click="ppxq()">
                <van-image fit="contain" :src="tuluTk.cover_pic"/>
            </div>
            <div class="book-rightB">
                <van-button type="primary" size="mini" class="tuluTk_btn tuluTk_btn_1" @click="chujia(chujiadis)" v-if="baseList.online_auction_type==1">出价</van-button>
                <!-- <van-button type="primary" size="mini" class="tuluTk_btn tuluTk_btn_1" @click="chujia()">出价</van-button> -->
                <!-- <span class="tuluTk_btn tuluTk_btn_2" v-if="baseList.online_auction_type==1" @click="chongzhi()">去充值 ></span> -->

                <template v-for="items in tuluTk.extra_info">
                    <div class="rightB1" :key="items.label" v-if="items.label=='当前价'">
                        <span class="rightB1-1">当前价</span>
                        <span class="rightB1-2">{{items.small_text}}</span>
                        <span class="rightB1-3">{{items.text}}</span>
                    </div>
                    <div class="rightB2" :key="items.label" v-if="items.label=='估价'">
                        <span class="rightB2-1">估价</span>
                        <span class="rightB2-2">{{items.small_text}}</span>
                        <span class="rightB2-3">{{items.text}}</span>
                    </div>
                    <div class="rightB2" :key="items.label" v-if="items.label=='下口价'&&baseList.online_auction_type==1">
                        <span class="rightB2-1">下口价</span>
                        <span class="rightB2-2">{{items.small_text}}</span>
                        <span class="rightB2-3">{{items.text}}</span>
                    </div>
                </template>
                <!-- <div class="rightB3" :key="items.label" v-if="items.label=='竞拍额度'"> -->
                <!-- <div class="rightB3" v-if="baseList.online_auction_type==1&&liveData.isLogin==1">
                    <span class="rightB3-1">竞拍额度</span>
                    <span class="rightB3-2">RMB {{tuluTk.deposit_amount}}</span>
                </div> -->
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props:["focusShow","liveData","baseList","tuluTk","chujiadis","yhxx"],
    data() {
        return {
            contShow: this.focusShow, //显示
            liveDatas:'',//数据
            //company_data:'',//拍卖机构信息
            //baseList:'',//基础
            tcShows:'',//
            t:'',
        };
    },
    mounted(){
        this.t = Date.now()
    },
    methods: {
        // 跳转拍品详情
        ppxq() {
            if(this.$route.query.from=='2'){//有水印
                //this.$router.push({path: '/auction',query:{ liveid:Number(this.$route.query.id),art_id:this.tuluTk.art_id,from:'2'}});
                this.$router.push(`auction/${this.$route.query.id}/${this.tuluTk.art_id}/${this.$route.query.special_id}`+'?from=2&btnShow=1')
            }else{//无水印
                //this.$router.push({path: '/auction',query:{ liveid:Number(this.$route.query.id),art_id:this.tuluTk.art_id}});
                this.$router.push(`auction/${this.$route.query.id}/${this.tuluTk.art_id}/${this.$route.query.special_id}`+'?btnShow=1')
            }
        },
        // 关闭
        contClick() {
            this.contShow = false;
            /* this.$parent.focusXian(30); */
        },
        // 出价
        chujia(chujiadis) {
            
            
            //this.$parent.offerOver('1',this.tuluTk);
            if(this.liveData.isLogin==0){
                this.$parent.noLogin()
            }else if(this.liveData.isLogin==1){
                if(this.yhxx.imRoles!=''&&this.yhxx.imRoles!=null&&this.yhxx.imRoles!=undefined){
                    var liveid=this.$route.query.id//直播id
                    var special_id=this.$route.query.special_id//专场id
                    var uid=this.yhxx.imRoles.length>0 ? this.yhxx.imRoles[0].uid : this.yhxx.defaultRoles.uid//用户id
                    var agreementChecked=sessionStorage.getItem('agreementChecked');
                    var agreementCheckedArr=[];
                    if(agreementChecked!=''&&agreementChecked!=null&&agreementChecked!=undefined){
                        agreementCheckedArr=agreementChecked.split("、");
                    }
                    let i=0;
                    agreementCheckedArr.forEach(item => {
                        if(item==liveid+'-'+special_id+'-'+uid){
                            if(chujiadis==true){//自由出价
                                this.$parent.offerOver('2',this.tuluTk);
                            }else{//下口价出价
                                this.$parent.offerOver('1',this.tuluTk);
                            }
                        }else{
                            i++
                        }
                    });
                    console.log(i)
                    console.log(agreementCheckedArr.length)
                    if(i==agreementCheckedArr.length){
                        this.$parent.agreementOverFu(true);
                    }
                }
            }
        },
        // 充值
        chongzhi() {
            if(this.liveData.isLogin==0){
                this.$parent.noLogin()
            }else if(this.liveData.isLogin==1){
                window.location.href = this.baseList.deposit_url; 
            }
        },
        focusFun(show){
            this.contShow=show;
            this.tcShows='false';
        }
    },
};
</script>

<style lang="scss" scoped>
.live-book {
    width: 94%;
    padding: 0.5rem;
    background-color: #ffffff;
    position: absolute;
    bottom: 4rem;
    left: 3%;
    border-radius:6px;
    z-index:99;

    .book-trigon {
        width: 0rem;
        height: 0rem;
        border-left: 0.3rem solid transparent;
        border-right: 0.3rem solid transparent;
        border-top: 0.3rem solid #ffffff;
        border-bottom: 0.3rem solid transparent;
        position: absolute;
        bottom: -0.58rem;
        left: 0.6rem;
    }
    .book-clock {
        position: absolute;
        top: 0rem;
        right: 0rem;
        z-index:1999;
    }
    .book-content {
        display: flex;
        align-items: center;

        .book-biaoti {
            width: 11.5rem;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            word-break: break-all;
            padding-left: 0.3rem;
            font-size: 0.7rem;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #27282d;
            line-height: 0.8rem;
        }
    }
    .book-tuwen {
        padding: 0.4rem 0rem;
        overflow:hidden;
        position:relative;
        .imgg {
            float: left;
            width: 2.5rem;
            height: 3rem;
            background-color: #eee;
            img {
                width: 100%;
                height: auto;
            }
        }
        .book-rightB {
            float: left;
            padding-left: 0.5rem;
            width: calc(100% - 2.5rem);
            /* min-height:1.2rem; */
            height:3rem;
            position:absolute;
            bottom:0.3rem;
            right:0px;
            .tuluTk_btn{
                position:absolute;
                right:0px;
                z-index:99;
            }
            .tuluTk_btn_1{
                bottom:0rem;
                font-size:0.7rem;
                height:1.4rem;
                border-radius: 0.8rem;padding: 0.5rem 0.8rem;
            }
            .tuluTk_btn_2{
                bottom:0.2rem;
                font-size:0.5rem;
            }
            .rightB1 {
                .rightB1-1 {
                    font-size: 0.6rem;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #969696;
                    line-height: 0.7rem;
                }
                .rightB1-2 {
                    font-size: 0.5rem;
                    font-family: DINAlternate-Bold, DINAlternate;
                    font-weight: bold;
                    color: #ff3b30;
                    line-height: 0.55rem;
                }
                .rightB1-3 {
                    font-size: 0.8rem;
                    font-family: DINAlternate-Bold, DINAlternate;
                    font-weight: bold;
                    color: #ff3b30;
                    line-height: 0.95rem;
                }
            }
            .rightB2 {
                width: 100%;
                //padding: 0.3rem 0rem;
                min-height: 1.5rem;
                line-height: 1.5rem;
                .rightB2-1 {
                    font-size: 0.6rem;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #969696;
                    line-height: 0.7rem;
                }
                .rightB2-2 {
                    font-size: 0.5rem;
                    font-family: DINAlternate-Bold, DINAlternate;
                    font-weight: bold;
                    color: #969696;
                    line-height: 0.55rem;
                }
                .rightB2-3 {
                    font-size: 0.8rem;
                    font-family: DINAlternate-Bold, DINAlternate;
                    font-weight: bold;
                    color: #969696;
                    line-height: 0.95rem;
                }
                .chujia {
                    width: 3rem;
                    height: 1.5rem;
                    background: #18bd6f;
                    border-radius: 0.75rem;
                    text-align: center;
                    line-height: 1.5rem;
                    float: right;
                    color:#fff;
                    // margin-left: 2rem;
                }
            }

            .rightB3 {
                padding: 0.2rem 0rem;
                width: 100%;
                .rightB3-1 {
                    font-size: 0.5rem;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #969696;
                }
                .rightB3-2 {
                    font-size: 0.5rem;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #ff3b30;
                }
                .rightB3-3 {
                    display: block;
                    float: right;
                    // margin-left: 3rem;
                    font-size: 0.5rem;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #27282d;
                }
            }
        }
    }
}

.load_box{
    width:100%;
    position:absolute;
    top:0px;
    left:0px;
    z-index:999;
    text-align:center;
    background:#fff;
}
.load_icon{
    width:4rem;
}
.van-image{
    width:100%;
    height:100%;
}
</style>